/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { InformativePaDetail } from "./InformativePaDetail";
import * as t from "io-ts";

// required attributes
const InformativePaFasceR = t.interface({});

// optional attributes
const InformativePaFasceO = t.partial({
  id: t.Integer,

  oraA: t.string,

  oraDa: t.string
});
// NOTE: fix-circular-generated-models: patched to break a circular
// import cycle detected among: InformativePaFasce, InformativePaDetail, InformativePaMaster, IbanValidiPerPa, IbanAttributeMaster, Iban, IbanMaster, Pa.
// This block is regenerated automatically by
// scripts/fix-circular-generated-models.js after every `gen-api-models` run
// - do not hand-edit `generated/` files, they are wiped on each generation.
export type InformativePaFasce = t.TypeOf<typeof InformativePaFasceR> &
  t.TypeOf<typeof InformativePaFasceO> & {
  readonly "fkInformativaPaDetail"?: InformativePaDetail;
  };

export const InformativePaFasce: t.Type<InformativePaFasce> = t.recursion("InformativePaFasce", () =>
  t.intersection(
    [InformativePaFasceR, t.partial({ ...InformativePaFasceO.props, "fkInformativaPaDetail": InformativePaDetail })],
    "InformativePaFasce"
  ) as unknown as t.Type<InformativePaFasce>
);
